
// paths for not to show chatbot ui
export const isRestrictedPath = (url) => {
    if (typeof url !== 'string') return false;

    const restrictedSegments = [
        "create", "edit", "play", "fill", "batch",
        "following", "followers", "passbook", "messenger",
        "my-referral", "settings", "business", "preview", "review"
    ];

    const segments = url.toLowerCase().split('/').filter(Boolean);

    return segments.some(segment => restrictedSegments.includes(segment));
};

export function escapeHtml(html) {
    return html
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

export const ImageUrl = "https://s3.ap-south-1.amazonaws.com/static3.tagtaste.com/avatars/pihu_icon_read.png"